const dayMs = 24 * 60 * 60 * 1000;
export function dayKeyAndLabel({
  iso,
  timeZone,
}: {
  readonly iso: string;
  readonly timeZone: string;
}): {
  readonly key: string;
  readonly monthDay: string;
} {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "long",
    day: "numeric",
  }).formatToParts(new Date(iso));
  const get = (t: string) => parts.find((p) => p.type === t)?.value ?? "";
  return {
    key: `${get("year")}-${get("month")}-${get("day")}`,
    monthDay: `${get("month")} ${get("day")}`,
  };
}
function dayNumberParts({
  iso,
  timeZone,
}: {
  readonly iso: string;
  readonly timeZone: string;
}): {
  readonly y: number;
  readonly m: number;
  readonly d: number;
} {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "numeric",
    day: "numeric",
  }).formatToParts(new Date(iso));
  const get = (t: string) =>
    Number(parts.find((p) => p.type === t)?.value ?? "0");
  return { y: get("year"), m: get("month"), d: get("day") };
}
export function calendarDaysBetween({
  earlierIso,
  laterIso,
  timeZone,
}: {
  readonly earlierIso: string;
  readonly laterIso: string;
  readonly timeZone: string;
}): number {
  const a = dayNumberParts({
    iso: earlierIso,
    timeZone,
  });
  const b = dayNumberParts({
    iso: laterIso,
    timeZone,
  });
  const aUtc = Date.UTC(a.y, a.m - 1, a.d);
  const bUtc = Date.UTC(b.y, b.m - 1, b.d);
  return Math.round((bUtc - aUtc) / dayMs);
}
